import controller from './appointment-finder.controller';
import template from './appointment-finder.html';

const appointmenFinderComponent = {
	bindings: {
		language: '<'
	},
	controller,
	template,
};

export default appointmenFinderComponent;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/appointment-finder/appointment-finder.component.js